import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0508 from "../lesson-08/lesson";
import lesson0512 from "../lesson-12/lesson";
import lesson0517 from "../lesson-17/lesson";
import lesson0528 from "../lesson-28/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "81b97121-dc97-4268-b061-37dc68228439",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0508),
    lesson: lesson0508,
  },
  {
    id: "3056e1d6-cba6-40a6-aac0-f97d7b298213",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0512),
    lesson: lesson0512,
  },
  {
    id: "b9d74506-7038-4e3f-9529-971db82f7ccd",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0517),
    lesson: lesson0517,
  },
  {
    id: "f39c87f8-761d-4aab-8eea-fc74524e5d85",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0528),
    lesson: lesson0528,
  },
];

export default lessonLinks;
